const messagesRU = {
    code: "en",
    messages: {
        included: (field) => `Это   поле "${field}" не является допустимым значением`,
        url: (field) => `Это поле "${field}" должно быть допустимым URL-адресом`,
        alpha: (field) => ` Это поле "${field}" может содержать только алфавитные символы`,
        alpha_num: (field) => `Это поле "${field}" может содержать только буквенно-цифровые символы`,
        alpha_dash: (field) =>
            `Это поле "${field}" может содержать буквенно-цифровые символы, а также тире и подчеркивания`,
        alpha_spaces: (field) => `Это поле "${field}" может содержать только алфавитные символы, а также пробелы`,
        between: (field, min, max) => ` Это поле "${field}" должно находиться в диапазоне от ${min} до ${max}`,
        confirmed: (field, field2) =>
            ` Подтверждение поля "${field}" не совпадает,${field2} и ${field} должны совпадать`,
        digits: (field, length) => `Поле «${field}» должно быть числовым и точно содержать цифры ${length}`,
        dimensions: (field, width, height) =>
            ` Поле "${поле}" должно быть размером ${ширина} пикселей на ${высота} пикселей`,
        email: (field) => ` Поле "${field}" должно быть действительным электронным письмом`,
        excluded: (field) => ` Поле "${field}" не является допустимым значением`,
        ext: (field) => ` Поле "${field}" не является допустимым файлом`,
        image: (field) => ` Поле "${field}" должно быть изображением`,
        integer: (field) => ` Поле "${field}" должно быть целым числом`,
        length: (field, length) => ` Поле "${field}" должно быть длиной ${length}`,
        max_value: (field, max) => ` Поле "${field}" должно быть ${max} или меньше`,
        max: (field, length) => ` Поле "${field}" не может быть больше символов ${length}`,
        mimes: (field) => ` Поле "${field}" должно иметь допустимый тип файла`,
        min_value: (field, min) => ` Поле "${field}" должно быть ${min} или больше`,
        min: (field, length) => ` Поле "${field}" должно содержать не менее символов ${length}`,
        numeric: (field) => ` Поле "${field}" может содержать только числовые символы`,
        oneOf: (field) => ` Поле "${field}" не является допустимым значением`,
        regex: (field) => ` Недопустимый формат поля "${field}” `,
        required_if: (field) => ` Поле "${field}" обязательно`,
        required: (field) => ` Поле "${field}" обязательно`,
        size: (field, size) => ` Размер поля "${field}" должен быть меньше ${size}K`,
    },
};
export default messagesRU;
